
import { DocumentContentEditor } from "./DocumentContentEditor";

interface UserResearchPlanViewProps {
  content: any;
  documentId: string;
  onUpdate: () => void;
}

export function UserResearchPlanView({ content, documentId, onUpdate }: UserResearchPlanViewProps) {
  return (
    <div className="space-y-8">
      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Research Objectives</h2>
        <DocumentContentEditor
          section="Research Objectives"
          content={content.researchObjectives}
          documentId={documentId}
          field="researchObjectives"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Target Audience</h2>
        <DocumentContentEditor
          section="Target Audience"
          content={content.targetAudience}
          documentId={documentId}
          field="targetAudience"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Research Methods</h2>
        <DocumentContentEditor
          section="Research Methods"
          content={content.researchMethods}
          documentId={documentId}
          field="researchMethods"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Data Analysis</h2>
        <DocumentContentEditor
          section="Data Analysis"
          content={content.dataAnalysis}
          documentId={documentId}
          field="dataAnalysis"
          onUpdate={onUpdate}
        />
      </section>
    </div>
  );
}
